import { useEffect, useMemo, useState } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildGetAccountRolesRequest, filterActiveRoles } from '../utils';

const useGetAccountRoles = () => {
  const [debouncedRoleInput, setDebouncedRoleInput] = useState('');
  const accountId = useCurrentAccountId();
  const {
    data: accountRolesData,
    loading: isFetchingAccountRoles,
    doFetch: doGetAccountRoles,
  } = useDataApi();
  const { results: accountRoles } = accountRolesData || { results: [] };

  const activeAccountRoles = useMemo(
    () => filterActiveRoles(accountRoles),
    [accountRoles]
  );

  const onChangeRoleInput = (roleInput) => {
    setDebouncedRoleInput(roleInput);
  };

  useEffect(() => {
    doGetAccountRoles(
      buildGetAccountRolesRequest(accountId, debouncedRoleInput)
    );
  }, [debouncedRoleInput, accountId, doGetAccountRoles]);

  return { activeAccountRoles, isFetchingAccountRoles, onChangeRoleInput };
};

export default useGetAccountRoles;
